"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseServerErrorMessage = void 0;
var parseServerErrorMessage = exports.parseServerErrorMessage = function parseServerErrorMessage(endpoint, data) {
  if (!data) return '';
  if (data.hasOwnProperty('o') && !data.o) return '';
  if (data.RejectMessage) return data.RejectMessage;
  return "".concat(endpoint, " - ").concat(data.errormsg || data.Errormsg).concat(data.detail ? " - ".concat(data.detail) : '');
};